/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type WatchList = {
    readonly id: number;
    /**
     * Object creation date
     */
    readonly created_date: string;
    /**
     * Object modification date
     */
    readonly modified_date: string;
    /**
     * `true` if a watch list is enabled
     */
    active?: boolean;
    /**
     * Short watch list name, up to 256 characters
     */
    name: string;
    /**
     * Extended description, up to 2048 characters
     */
    comment?: string;
    /**
     * Color of the object label in hex
     */
    color?: string;
    /**
     * `true` if the notifications on the watch list enabled
     */
    notify?: boolean;
    /**
     * Require manual acknowledgment of the events that match with the watch list
     */
    acknowledge?: boolean;
    permissions?: Record<string, string>;
    /**
     * List of the camera groups used to monitor the watch list 
     */
    camera_groups?: Array<number>;
    /**
     * Watch list face confidence threshold
     */
    face_threshold?: number | null;
    /**
     * Watch list body confidence threshold
     */
    body_threshold?: number | null;
    /**
     * Watch list car confidence threshold
     */
    car_threshold?: number | null;
    /**
     * Events won't be created if set to True
     */
    ignore_events?: boolean;
    /**
     * `true` if events matched with this watch list should be sent to an external VMS
     */
    send_events_to_external_vms?: boolean;
    /**
     * bit
     */
    origin?: string;
    /**
     * `true` to enable daily search for cards from this watch list
     */
    collect_location?: boolean;
};
export const EmptyWatchList: WatchList = {
    id: 0,
    /**
     * Object creation date
     */
    created_date: '',
    /**
     * Object modification date
     */
    modified_date: '',
    /**
     * `true` if a watch list is enabled
     */
    active: true,
    /**
     * Short watch list name, up to 256 characters
     */
    name: '',
    /**
     * Extended description, up to 2048 characters
     */
    comment: '',
    /**
     * Color of the object label in hex
     */
    color: 'cccccc',
    /**
     * `true` if the notifications on the watch list enabled
     */
    notify: false,
    /**
     * Require manual acknowledgment of the events that match with the watch list
     */
    acknowledge: false,
    permissions: {},
    /**
     * List of the camera groups used to monitor the watch list 
     */
    camera_groups: [],
    /**
     * Watch list face confidence threshold
     */
    face_threshold: null,
    /**
     * Watch list body confidence threshold
     */
    body_threshold: null,
    /**
     * Watch list car confidence threshold
     */
    car_threshold: null,
    /**
     * Events won't be created if set to True
     */
    ignore_events: false,
    /**
     * `true` if events matched with this watch list should be sent to an external VMS
     */
    send_events_to_external_vms: false,
    /**
     * `true` to enable daily search for cards from this watch list
     */
    collect_location: false,
};